import React, {useMemo} from 'react';
import {ScrollView, View, Image, StyleSheet} from 'react-native';
import {useInnerStyle} from '../invitation.style.hooks';
import theme from '@/style';
import DetailNavTitle from '@/components/business/detail-nav-title';
import InvitationRuleTable from './invitation-rule-table';
import {goBack} from '@/utils';
import {useTranslation} from 'react-i18next';
import {t} from 'i18next';

const PAGE_BG_COLOR = '#472236';

const InvitationRule = () => {
  const {
    size: {screenHeight, screenWidth},
  } = useInnerStyle();
  const {i18n} = useTranslation();
  const bannerImg = useMemo(() => {
    return i18n.language === 'bn_BD'
      ? require('@/assets/imgs/invitation/header-bn.webp')
      : require('@/assets/imgs/invitation/header.webp');
  }, [i18n.language]);
  const rulesImg = useMemo(() => {
    return i18n.language === 'bn_BD'
      ? require('@/assets/imgs/invitation/rules-bn.webp')
      : require('@/assets/imgs/invitation/rules.png');
  }, [i18n.language]);
  const rewardImg = useMemo(() => {
    return i18n.language === 'bn_BD'
      ? require('@/assets/imgs/invitation/reward-header-bn.webp')
      : require('@/assets/imgs/invitation/reward-header.png');
  }, [i18n.language]);
  return (
    <View
      style={[
        {height: screenHeight, backgroundColor: PAGE_BG_COLOR},
        theme.fill.fillW,
        theme.flex.col,
      ]}>
      <DetailNavTitle
        hideAmount
        serverRight
        title={t('invitation.rule.title')}
        onBack={goBack}
      />
      <ScrollView style={[theme.flex.flex1]}>
        {/* 顶部Banner图片 */}
        <div className="flex flex-col">
          <Image
            source={bannerImg}
            style={{
              width: screenWidth,
              height: (screenWidth / 378) * 294,
            }}
            resizeMode="cover"
          />
        </div>
        {/* 规则说明与步骤说明合并卡片 */}
        <View style={[theme.flex.col, theme.padding.l]}>
          <View style={styles.rulesImgWrap}>
            <Image
              source={rulesImg}
              style={styles.rulesImg}
              resizeMode="cover"
            />
          </View>
          <View style={styles.rewardImgWrap}>
            <Image
              source={rewardImg}
              style={styles.rewardImg}
              resizeMode="cover"
            />
          </View>
          <InvitationRuleTable />
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  gradientTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#c9b65b',
  },
  subTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#c9b65b',
    textAlign: 'center',
  },
  bullet: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: '#c9b65b',
    marginRight: 8,
  },
  stepText: {
    color: '#c9b65b',
    fontSize: 12,
  },
  ruleDesc: {
    color: '#c9b65b',
    fontSize: 12,
    textAlign: 'left',
    marginBottom: 8,
  },
  rulesImgWrap: {
    width: '100%',
    borderRadius: 16,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#d0bd88',
    backgroundColor: '#5d1b3f',
    marginBottom: 16,
    // 可选：添加阴影
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 2,
  },
  rulesImg: {
    width: '100%',
    aspectRatio: 1022 / 822, // 按原图比例
    height: undefined,
    minHeight: 120,
    maxHeight: 400,
    display: 'flex',
  },
  rewardImgWrap: {
    width: '100%',
    marginBottom: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rewardImg: {
    aspectRatio: 440 / 2 / (47 / 2),
    height: 47 / 2,
    resizeMode: 'contain',
    display: 'flex',
  },
});

console.log(styles);
export default InvitationRule;
